<template>
    <div class="mb-3">
        <b-row no-gutters>
            <b-col md="12" class="my-1 d-flex" v-if="!hideHeader">
                <b-button
                    v-if="auth_level >= '100' && formModalId && !hideAdd"
                    variant="none"
                    class="mr-2"
                    @click="add"
                    >
                    <font-awesome-icon icon="plus" />
                </b-button>
                <b-form class="flex-grow-1" @submit="search">
                    <b-form-group class="mb-0">
                        <b-input-group>
                            <b-form-input
                                v-model="grid.filters.q"
                                :placeholder="filtersQPlaceholder"
                                type="search"
                                ></b-form-input>
                            <b-input-group-append>
                                <b-button type="submit">
                                    <font-awesome-icon icon="search" />
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-form>
                <b-button
                    variant="none"
                    class="ml-2"
                    @click="ui.showGridFilter = !ui.showGridFilter"
                    >
                    <font-awesome-icon icon="sliders-h" />
                </b-button>
            </b-col>
            <b-col md="12">
                <b-collapse id="grid-filter" v-model="ui.showGridFilter">
                    <b-row class="mx-0">
                        <b-col class="text-right">
                            <small>
                                <b-link @click="resetFilter">クリア</b-link>
                            </small>
                        </b-col>
                    </b-row>
                    <b-row class="mx-0">
                        <filter-item
                            v-for="item in filterItems"
                            :key="item.vModel"
                            v-model="grid.filters[item.vModel]"
                            :title="item.title"
                            :options="item.options"
                            @input="search"
                            />
                    </b-row>
                </b-collapse>
            </b-col>
        </b-row>
    
        <template v-if="grid.response.data && grid.response.data.hits && grid.response.data.hits.length">
            <b-table
                :items="grid.response.data.hits"
                :fields="[{ key: 'column', class: 'text-left' }]"
                hover
                thead-class="font-weight-bold"
                thead-tr-class="d-none"
                @row-clicked="onRowClicked"
                >
                <template slot="thead-top" slot-scope="data">
                    <b-row class="d-none d-md-flex p-2">
                        <slot :item="data.item" name="header"></slot>
                    </b-row>
                </template>
                <template v-slot:cell(column)="data">
                    <b-row :class="'d-flex p-0 ' + rowClass">
                        <slot :item="data.item" name="column"></slot>
                    </b-row>
                </template>
            </b-table>
    
            <Pagenation
                v-model="grid.filters.page"
                :nb-pages="grid.response.data.nbPages"
                :nb-hits="grid.response.data.nbHits"
                @input="pagenation"
                />

        </template>
    
        <template v-if="mounted">
            <slot :form="form" :init="detail" name="form"></slot>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterItem from '@/components/FilterItem.vue'
import Pagenation from '@/components/Pagenation.vue'

export default {
    components: {
        FilterItem,
        Pagenation,
    },
    props: {
        filtersQPlaceholder: {
            type: String,
            required: true,
            default() {
                return 'キーワード'
            },
        },
        filtersDefault: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        filterItems: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        formModalId: {
            type: String,
            required: false,
            default() {
                return ''
            },
        },
        formDefault: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        searchAction: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        afterMount: {
            type: Function,
            required: false,
            default() {
                return function () {}
            },
        },
        openDetailForOneHit: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        openDetailAfterSaving: {
            type: Boolean,
            required: false,
            default() {
                return true
            },
        },
        hideAdd: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        hideHeader: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        filterSearchResults: {
            type: [ Function, Boolean, ],
            required: false,
            default: true,
        },
        rowClicked: {
            type: [ Function, Boolean, ],
            required: false,
            default: true,
        },
        rowClass: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            grid: {
                filters: {
                    q: '',
                    page: 1,
                },
                response: {},
                error: {},
            },
            form: {
                log: [],
            },
            ui: {
                showGridFilter: false,
            },
            mounted: false,
        }
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_pages',
            'auth_batches',
        ])
    },
    watch: {
        $route: {
            async handler () {

                this.$bus.$emit('page:route-handler')
            },
            immediate: true
        }
    },
    mounted () {
        this.mounted = true

//        this.$bus.$on('grid-page:show-detail', (item) => {
////            this.pushGrid(item)
//            this.detail(item)
//                .then((item) => {
//                    this.pushGrid(item)
//                })
//        })

        setTimeout(() => {
            this.search()
        }, 1000)

        this.grid.filters = Object.assign(this.grid.filters, this.filtersDefault)

        if (this.$route.params.id) {
            this.grid.filters.q = this.$route.params.id
        }

        this.afterMount(this)
    },
    destroyed () {
    },
    methods: {
        // ...mapActions('member', ['searchMember']),
        search(event, page) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.grid.response = {}
            this.grid.error = {}
            this.ui.showGridFilter = false
            this.grid.filters.page = page || 1
            this.$store
                .dispatch(this.searchAction, Object.assign({}, this.filtersDefault, this.grid.filters))
//                .dispatch(this.searchAction, this.grid.filters)
                .then((response) => {
                    this.grid.response = JSON.parse(JSON.stringify(response.data))

                    if (typeof this.filterSearchResults === 'function') {
                        this.grid.response = this.filterSearchResults(this.grid.response)
                    }

                    if (this.openDetailForOneHit && this.grid.response.data.nbHits === 1) {
                        this.detail(this.grid.response.data.hits[0])
//                        this.detail(this.grid.response.data.hits[0], 0)
                    }
                })
                .catch((error) => {
                    this.grid.error = error
                })
        },
        pagenation(event) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.search(event, this.grid.filters.page)
        },
        add(event) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            if (!this.formModalId) {
                return
            }
            this.form = JSON.parse(JSON.stringify(this.formDefault))
            this.$bvModal.show(this.formModalId)
        },
        onRowClicked(item, index, event, show = true) {
            if (this.rowClicked === false) {
                return
            }
            if (typeof this.rowClicked === 'function') {
                return this.rowClicked(event, item, index, show)
            }
            return this.detail(item, index, event, show)
        },
        detail(item, index, event, show = true) {
            return new Promise((resolve, reject) => {
                if (!this.formModalId) {
                    reject(null)
                    return
                }
                this.$store
                    .dispatch(this.searchAction, { uuid: item.uuid })
                    .then((response) => {
                        this.form = response.data.data
                        if (show) {
                            this.$bvModal.show(this.formModalId)
                        }
                        this.$router.push({ name: this.$router.currentRoute.name, params: { item_uuid: item.uuid, }, })
                        resolve(response.data.data)
                    })
                    .catch((error) => {
                        this.grid.error = error
                        reject(error)
                    })
            })
        },
        pushGrid(item) {
            if (!this.grid.response.data.hits) {
                return
            }
            for (let i = 0; i < this.grid.response.data.hits.length; i++) {
                if (item.uuid === this.grid.response.data.hits[i].uuid) {
                    this.grid.response.data.hits[i] = Object.assign(
                    this.grid.response.data.hits[i],
                    item
                    )
                    return
                }
            }
            this.grid.response.data.hits.unshift(item)
        },
        deleteGrid(item) {
            for (let i = 0; i < this.grid.response.data.hits.length; i++) {
                if (item.uuid === this.grid.response.data.hits[i].uuid) {
                    this.grid.response.data.hits.splice(i, 1)
                    return
                }
            }
        },
        save(response) {
            this.pushGrid(response.data)
            if (this.openDetailAfterSaving) {
                this.detail(response.data)
            }
        },
        destroy(response) {
            this.deleteGrid(response.data)
        },
        resetFilter(event) {
            this.grid.filters = Object.assign({}, this.filtersDefault)
            this.search(event, this.grid.filters.page)
        },
    },
}
</script>

<style lang="scss" scoped>
.filter-item-option {
    display: block;

    &[active] {
    }

    &:not([active]) {
        opacity: 0.3;
    }

    [type='radio'] {
        display: none;
    }

    .filter-item-option-text {
        cursor: pointer;
    }
}
</style>
